import { getGlobalVariable } from "@/app/editor/config/globalVariable";
import { base } from '@/app/editor/sidebar/constant';
import HELPER from '@/app/utils/HELPER';
import replaceEscapeHtml from '@/app/utils/replaceEscapeHtml';
import { app } from '@/store';

(function (jQuery) {
  jQuery.gfVariantSelector = function (element, options) {
    const defaults = {
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let _productData = {};
    let $elementSelect;

    /* Editor */
    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
    const $gryffBody = getGlobalVariable('gryffBody');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element.hide();

      this.applyEvents();

      $element.on('value-change', function () {
        $element.trigger('input-change');

        const variantId = $element.attr('value');
        const $selected = $elementSelect.find('select');
        if (variantId != 'auto') {
          for (let i = 0; i < _productData['product'].variants.length; i++) {
            if (_productData['product'].variants[i].id.toString() == variantId.toString()) {
              const options = jQuery.map(_productData['product'].variants[i].title.split('/'), jQuery.trim);
              for (var h = 0; h < $selected.length; h++) {
                jQuery($selected[h]).data('gfdropdown').setValue(options[h]);
              }
              break;
            }
          }
        } else {
          for (var h = 0; h < $selected.length; h++) {
            jQuery($selected[h]).data('gfdropdown').setValue('default');
          }
        }
      });
    };

    this.applyEvents = function () {
      const moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
      const $product = $gryffBody.find('#m-' + moduleId);

      // This is for default product in template
      if ($product.attr('data-status') == 'default' || $product.attr('data-status') == 'dynamic') {
        $element.closest('.columns').hide();
      } else {
        $element.closest('.columns').show();
      }

      if ($product.children('[data-pid]').length > 0) {
        const productId = $product.children('[data-pid]').attr('data-pid');
        const productData = HELPER.searchProductInList(productId);
        const jsonHtml = '{"product":' + JSON.stringify(productData) + '}';

        try {
          _productData = jQuery.parseJSON(jsonHtml);
          let html = '<div class="gryff_layout-onion">';

          const optionsLength = _productData['product']['options'].length;
          for (let i = 0; i < optionsLength; i++) {
            const option = _productData['product']['options'][i];
            html += '<label class="gfSGSubTitle">' + option.name + '</label>';
            html += '<div class="gfSGclear"></div>';
            html += '<select class="gfVariantSelector-select" value="">';
            html += '<option value="default">Default</option>';
            for (let j = 0; j < option.values.length; j++) {
              html += `<option value="${replaceEscapeHtml(option.values[j])}">${option.values[j]}</option>`;
            }
            html += '</select>';
          }
          html += '</div>';

          $element.hide();
          $elementSelect = jQuery(html);
          $element.after($elementSelect);

          const moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
          
          // init options
          const variantId = $element.val();
          _this.setOptionsByVariantId(variantId);
          // gfDropDown;
          const $selected = $elementSelect.find('select');
          const selectedLength = $selected.length;
          for (let i = 0; i < selectedLength; i++) {
            $($selected[i]).gfDropDown({
              onSelected: function (selectedValue) {
                const values = [];
                try {
                  const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
                  const settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
                  const fields = jQuery.parseJSON(settings);
                  fields?.map((field) => {
                    if (field.id === 'variant') {
                      const selectedOptions = []
                      $element
                      .siblings('.gryff_layout-onion')
                      .find('.gfVariantSelector-select')
                      .each(function () {
                        const value = jQuery(this).val();
                        selectedOptions.push(value)
                      });
                      
                      field['selectedOptions'] = selectedOptions;

                      return field;
                    }
                    return field;
                  })

                  app.$store.commit('editor/SET_DATA_SETTINGS', {
                    id: keySettings,
                    value: JSON.stringify(fields),
                  });

                } catch (err) {
                  console.log(err.message);
                }

                let countDefault = 0;
                setTimeout(function () {
                  const $gfVariantSelector = $element.siblings('.gryff_layout-onion').find('.gfVariantSelector-select');
                  $gfVariantSelector.each(function () {
                    const value = $(this).attr('value');
                    values.push(value);
                    if (value && value.toLowerCase() == 'default') {
                      countDefault++;
                    }
                  });
                  const totalOption = $gfVariantSelector.length;
                  let variantId;
                  
                  // are not default options
                  if(countDefault !== totalOption) {
                    variantId = _this.getVariant(values).id;
                  } else {
                    variantId = 'auto';
                  }

                  $element
                    .val(variantId)
                    .attr('value', variantId)
                    .attr('data-value', variantId)
                    .trigger('input-change');
                }, 100);
              },
            });
          }
        } catch (err) {
          console.log(err.message);
        }
      }
      return false;
    };

    this.getVariant = function (values) {
      let selectedVariantId = 0;
      const orderedValues = values.sort().join(',');

      for (let i = 0; i < _productData['product'].variants.length; i++) {
        let options = jQuery.map(_productData['product'].variants[i].title.split('/'), jQuery.trim);

        //newversion variant options
        const tempOptions = [];
        for (let j = 1; j <= 3; j++) {
          if (_productData['product'].variants[i] && _productData['product'].variants[i]['option' + j]) {
            tempOptions.push(_productData['product'].variants[i]['option' + j]);
          }
        }
        if (tempOptions.length) {
          options = tempOptions;
        }

        const orderedOptions = options.sort().join(',');

        if (orderedValues == orderedOptions) {
          selectedVariantId = i;
          break;
        }
      }
      return _productData['product'].variants[selectedVariantId];
    };

    this.setOptionsByVariantId = function (variantId) {
      if (variantId != 'auto') {
        for (var i = 0; i < _productData['product'].variants.length; i++) {
          if (_productData['product'].variants[i].id.toString() == variantId.toString()) {
            var options = jQuery.map(_productData['product'].variants[i].title.split('/'), jQuery.trim);
            var k = 0;

            $element
              .siblings('.gryff_layout-onion')
              .find('.gfVariantSelector-select')
              .each(function (index) {
                let value = options[k];

                //newversion variant options
                if (
                  _productData['product'].variants[i] &&
                  _productData['product'].variants[i]['option' + (index + 1)]
                ) {
                  value = _productData['product'].variants[i]['option' + (index + 1)];
                }
                jQuery(this).val(value).attr('value', value);
                k++;
              });
            break;
          }
        }
      } else {
        $element.siblings('.gryff_layout-onion').find('.gfVariantSelector-select').val('').attr('value', '');
      }
      return false;
    };

    this.init();
  };

  jQuery.fn.gfVariantSelector = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfvariantselector')) {
        const plugin = new jQuery.gfVariantSelector(this, options);
        jQuery(this).data('gfvariantselector', plugin);
      }
    });
  };
})(jQuery);
